module.exports = __webpack_public_path__ + "img/price.94bbe356.svg";